<template>
  <div class="modal-overlay" @click="toggleModals" @keypress="toggleModals">
    <div class="warning-modal">
      <div class="warning-header">{{ title }}</div>
      <div class="heading-text">{{ body }}</div>
      <div class="heading-button" @click="toggleModals" @keypress="toggleModals">ОК</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export default {
  name: 'ModalWarning',
  computed: {
    ...mapState(GENERAL_STORE, ['warningMessageData']),

    title() {
      return this.warningMessageData.title || 'Произошла ошибка'
    },

    body() {
      return this.warningMessageData.body || ''
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleModals']),
  },
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  color: #495057;

  background-color: rgb(112 112 112 / 50%);

  .warning-modal {
    z-index: 101;

    max-width: 325px;
    padding: 35px 55px;

    background-color: #f7f7f7;
    border-radius: 7px;

    .warning-header {
      font-size: 14px;
      font-weight: 700;
      text-align: center;
    }

    .heading-text {
      margin-top: 12px;
      margin-bottom: 25px;

      font-size: 13px;
      text-align: center;
    }

    .heading-button {
      cursor: pointer;

      max-width: 145px;
      margin: 0 auto;
      padding: 8px 25px;

      font-size: 13px;
      color: #fffefe;
      text-align: center;

      background-color: #de3e26;
      border-radius: 20px;
    }
  }
}
</style>
